import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function BaggageSDisabledStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M8.61997 13.42C7.98997 13.6 7.38997 13.82 6.84997 14.1V12C6.84997 9.16 9.15997 6.84 12.01 6.84C14.86 6.84 13.79 7.08 14.54 7.51L15.56 6.49C15.45 6.42 15.34 6.35 15.22 6.28V6.14C15.22 4.37 13.78 2.93 12.01 2.93C10.24 2.93 8.79997 4.37 8.79997 6.14V6.28C6.79997 7.41 5.44997 9.55 5.44997 12V16.6L8.62997 13.42H8.61997ZM12 4.33C12.84 4.33 13.54 4.9 13.75 5.67C13.19 5.52 12.61 5.43 12 5.43C11.39 5.43 10.81 5.51 10.25 5.67C10.46 4.9 11.16 4.33 12 4.33Z"
				fill="currentColor"
			/>
			<path
				d="M22.97 3.24L21.94 2.21L16.71 7.44C16.71 7.44 16.7 7.43 16.69 7.42L15.7 8.41C15.7 8.41 15.71 8.42 15.72 8.43L13.95 10.2C13.95 10.2 13.95 10.18 13.95 10.17L13.09 11.03H13.12L11.15 13C11.14 13 11.13 13 11.11 13L9.44997 14.66C9.45997 14.66 9.47997 14.66 9.48997 14.65L6.83997 17.3V17.27L5.42997 18.68V18.71L1.96997 22.17L2.99997 23.2L5.96997 20.23C6.40997 20.75 7.05997 21.09 7.79997 21.09H16.17C17.48 21.09 18.55 20.02 18.55 18.71V12.01C18.55 10.76 18.2 9.6 17.59 8.61L22.95 3.25L22.97 3.24ZM17.16 18.7C17.16 19.24 16.72 19.67 16.19 19.67H7.81997C7.46997 19.67 7.16997 19.49 6.99997 19.21L11.83 14.38C11.89 14.38 11.95 14.38 12.01 14.38C14 14.38 15.85 14.87 17.17 15.72V18.7H17.16ZM17.16 14.1C16.02 13.53 14.65 13.15 13.18 13.02L16.58 9.62C16.95 10.33 17.16 11.14 17.16 11.99V14.1Z"
				fill="currentColor"
			/>
			<path
				d="M10.74 9.62C10.35 9.62 10.04 9.94 10.04 10.32C10.04 10.7 10.36 11.02 10.74 11.02H11.01L12.42 9.61H10.75L10.74 9.62Z"
				fill="currentColor"
			/>
		</svg>
	);
}

BaggageSDisabledStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default BaggageSDisabledStrokeIcon;
